import styled from 'styled-components';

const DynamicCreativeOptimizationStyled = styled.div`
  .dynamicCreativeOptimization {
    &__content {
      &Action {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
      }

      &Counter {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 16px;
      }

      &SearchInput {
        width: 100%;
      }

      &Creative, &Contexts {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 8px;

        &Number{
          color: ${props => props.theme.uiColors.dcoTextColor};
          font-family: ${props => props.theme.fontRegular};
          font-size: ${props => props.theme.fontSizeM};
          letter-spacing: 0;
          font-weight: 400;
        }

        &Text {
          color: ${props => props.theme.uiColors.multiflightCreativesColor};
          font-size: ${props => props.theme.fontSizeXS};
          line-height: normal;
          letter-spacing: 0;
        }
      }

      &ActionSection {
        display: flex;
        justify-content: flex-end;
      }
    }

    &__emptyStateContainer, &__emptyStateText {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
    }

    &__emptyStateIcon {
      color: ${props => props.theme.uiColors.creativeBoldText};
      font-size: ${props => props.theme.fontSizeL};
    }

    &__emptyStateText {
      margin: 16px 0 32px 0;
    }

    &__title {
      color: ${props => props.theme.uiColors.dcoTextColor};
      font-size: ${props => props.theme.fontSizeM};
      font-weight: 400;
    }

    &__description {
      color: ${props => props.theme.uiColors.creativeBoldText};
      font-size: ${props => props.theme.fontSizeXXS};
      font-weight: 400;
    }

    &__toast {
      margin-bottom: 8px;
      background-color: ${props => props.theme.uiColors.contextualBiddingWarningToastBackgroundColor};
      color: ${props => props.theme.uiColors.contextualBiddingWarningToastColor};
      font-size: ${props => props.theme.fontSizeXXS};
      &Container {
        padding: 0 24px 24px 24px;
      }
    }
  }

  .inputSearch {
    flex: 1 1 auto;
    min-width: 80px;
    width: 100%;
    max-width: unset;

    .inputSearch__inputWithSymbol {
      height: 41px;
    }
  }
`;

export { DynamicCreativeOptimizationStyled };
